import { Controller } from "@hotwired/stimulus"
import { isInIframe, inputSubmitWith } from "lib/utilities";
import ahoy from "ahoy.js";

export default class extends Controller {

  // NOTE: Very similar to similarities#insert
  insert(event) {
    event.preventDefault();

    // Prevent multiple clicks from triggering multiple inserts
    if (event.detail > 1) return;

    let linkText = event.target.closest("a").innerText;
    this.trackEvent(linkText);
    inputSubmitWith("user-input", linkText);
  }

  // Note: Very similar to citations#log
  trackEvent(linkText) {
    let source;

    let eventName = 'RelatedQuestionClick';
    if (isInIframe()) {
      source = "iframe";
    } else {
      source = "direct";
    }

    ahoy.track(eventName, {
      linkText: linkText,
      source: source,
      organization: this.application.dewey?.organization?.name,
      organization_id: this.application.dewey?.organization?.id,
      user_id: this.application.dewey?.user?.id
    });
  }
}